/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow

import type { Element } from 'react';

import React from 'react';
import { Field } from 'redux-form';
import classNames from 'classnames';
import {
  designCodeYears,
  getDesignCodeYearDesc,
} from '#support/models/designCodeYears/designCodeYears.js';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';

type Props = {|
  form: string,
  name: string,
|};

const items = designCodeYears.map(year => ({
  id: year,
  name: getDesignCodeYearDesc(year),
  value: year,
}));

const CodeYearSelectMenu = (props: Props): Element<typeof Field> => {
  const { form, name } = props;
  return (
    <SelectMenu
      form={form}
      id={name}
      name={name}
      type="select"
      items={items}
      inputClassName={classNames('custom-select', 'code-year-select')}
    />
  );
};

export default CodeYearSelectMenu;
